import React from "react"
import Snackbar from "@mui/material/Snackbar"
import MuiAlert from '@mui/material/Alert'
import snackbarStore from "../stores/snackbarStore"
import { inject, observer } from "mobx-react"

@inject("snackbarStore")
@observer
export default class SFSnackbar extends React.Component {
  render() {
    const { snackbarStore } = this.props
    return (
      <Snackbar
        open={snackbarStore.open}
        onClose={() => snackbarStore.closeSnackbar()}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: snackbarStore.verticalPosition, horizontal: "center" }}
      >
        <MuiAlert elevation={6} onClose={snackbarStore.closeSnackbar} severity={snackbarStore.severity}>
          {snackbarStore.message}
        </MuiAlert>
      </Snackbar>
    )
  }
}
